import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { StylableComponent } from '@adsk/alloy-react-helpers';

type TableConfigurationResetProps = StylableComponent<HTMLButtonElement> & {
  label: ReactNode;
  reset: () => void;
};
const TableConfigurationReset: FC<TableConfigurationResetProps> = ({
  label,
  reset,
}) => (
  <LinkButton
    data-testid={'TableConfigurationMenu__ResetAll'}
    size={LinkButton.SIZES.SMALL}
    style={{ margin: '18px 24px' }}
    onClick={reset}
  >
    {label}
  </LinkButton>
);

TableConfigurationReset.propTypes = {
  label: PropTypes.node.isRequired,
  reset: PropTypes.func.isRequired,
};

export default TableConfigurationReset;
